import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { getAllBookings, deleteBooking } from '../api/auth/booknowService';

function Booknowdetails() {
    const [bookings, setBookings] = useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        try {
            const response = await getAllBookings();
            setBookings(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire(
                'Error!',
                'There was a problem fetching bookings.',
                'error'
            );
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this entry!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteBooking(id);
                    setBookings(bookings.filter(item => item.id !== id));
                    Swal.fire(
                        'Deleted!',
                        'The booking has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting booking:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the booking.',
                        'error'
                    );
                }
            }
        });
    };

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-0" style={{ marginLeft: '210px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="page-title">Book Now Detail</h5>
                        </div>
                    </div>
                </div>
                <br />
                <div className="col-md-12">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Plan Name</th>
                                <th scope="col">Price</th>
                                <th scope="col">Name</th>
                                {/* <th scope="col">Clinic Name</th> */}
                                <th scope="col">Phone</th>
                                <th scope="col">Email</th>
                                <th scope="col">Website</th>
                                <th scope="col">Address</th>
                                <th scope="col">Date</th>
                                <th scope="col" style={{ width: '120px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bookings.map(booking => (
                                <tr key={booking.id}>
                                    <td>{booking.plan_name}</td>
                                    <td>{booking.price}</td>
                                    <td>{booking.name}</td>
                                    {/* <td>{booking.clinicname}</td> */}
                                    <td>{booking.phone}</td>
                                    <td>{booking.email}</td>
                                    <td>{booking.websitename}</td>
                                    <td>{booking.address}</td>
                                    <td>{booking.date}</td>
                                    <td>

                                        <button
                                            className="btn btn-danger"
                                            style={{ background: 'red' }}
                                            onClick={() => handleDelete(booking.id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>



                    </table>
                </div>
            </div>
        </div>
    );
}

export default Booknowdetails;